<template>
  <el-container class="container-da">
    <div  class="left" v-show="print"  :width="asideWidth">
      <el-tabs tab-position="left" @tab-click="tabClick" ref="tabs" stretch >
        <el-tab-pane :label="tab.title" v-for="tab in tabs" :key="tab.title"></el-tab-pane>
      </el-tabs>
    </div>
      <div class="content">
        <div class="header"  v-show="print" v-if="histories.length > 1">
          <div class="history-wrapper">
            <router-link class="history-item"  v-for="(h, index ) in histories"  :class="$route.path === h.path ? 'item-active': ''" :to="{path: h.path, query: h.query, params: h.params}" :key="h.path">
              <span>{{ (h.stageId && list[h.stageId].title)  || h.title }}</span>
              <i class="el-icon-close" @click.stop.prevent="close(index)"></i>
            </router-link>
          </div>
        </div>
        <div class="flex: 1">
            <router-view></router-view>
        </div>
      </div>
      <i class="el-icon-printer icon" v-if="print" ref="printer" @click="printView" :style="printIcon"></i>
  </el-container>
</template> 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import router from '@/router/archives'
import request from '@/utils/request'
export default {
  name: "",
  data() {
    return {
      testshow: false,
      print: true,
      histories: [],
      tabs: [],
      list: {},
      projectid: this.$route.query.projectid,
      cosid: this.$route.query.cosid,
      ptcid: this.$route.query.ptcid,
      projectcode: this.$route.query.projectcode,
      pdsid: '',
      swiperOption: {
        slidesPerView: "auto",
        initialSlide: 0,
        effect: "slide",
        spaceBetween: 1,
        preventClicks: false,
        freeMode: true,
        mousewheel: {
          sensitivity: 1.5,
        },
      },
    };
  },
  async mounted() {
    // this.setResize();
    this.tabs = router[0].children
    this.init()
    await this._normizeRoute()
  },
  methods: {
    printView() {
      this.print = false
      setTimeout(() => {
        window.print()
      }, 200)
      setTimeout(() => {
        this.print = true
      }, 300)
    },
    init () {
        this.list = {}
        this.tabs.forEach(item => {
            this.list[item.meta.code] = item
        })
        this.$router.push({name: this.tabs[0].name, query: { cosid: this.cosid,projectid:this.projectid,ptcid:this.ptcid,Ptype:this.tabs[0].Ptype,projectcode:this.projectcode, pdsid: this.pdsid }})
    },
    setResize() {
      this.clientHeight = document.body.clientHeight;
      this.$refs.appMain.$el.style.minHeight = `${
        this.clientHeight - 60
      }px`;
    },
    tabClick(val) {
      let cureent = this.tabs[val.index]
      this.$router.push({name: cureent.name, query: { cosid: this.cosid,projectid:this.projectid,ptcid:this.ptcid,Ptype:cureent.Ptype,projectcode:this.projectcode, pdsid: this.pdsid }})
    },
    close(index) {
        if (this.$route.path === this.histories[index].path) {
            if (index > 0) {
                let prevRouter = this.histories[index - 1]
                this.$router.push({path: prevRouter.path, params: prevRouter.params, query: prevRouter.query})
            } else if (this.histories.length > 1) {
                let prevRouter = this.histories[1]
                this.$router.push({path: prevRouter.path, params: prevRouter.params, query: prevRouter.query})
            }
        }
        this.histories.splice(index, 1)
        this.histories = [...this.histories]
       
    },
    async _normizeRoute () {
        let res = await request({
            method: 'get',
            url: '/xmgl/pds/getpdsInfo',
            params: {cosid: this.cosid, projectid: this.projectid}
        })
        let { PDSLdata, PDSdata } = res
        // console.log(PDSLdata)
        PDSLdata = PDSLdata.filter(e=>{
          return +e.pdslselfcheckflag === 2 
        })

        const [pds] = PDSdata
        this.pdsid = pds.pdsid
        
        if (PDSLdata.length > 0) {
            let tempObj = {}
            const firstTab  = this.tabs[0]
            tempObj[firstTab.meta.code] = {
              code: firstTab.meta.code,
              pdslname: firstTab.meta.title,
              pdslseq: 0
            }
            PDSLdata.forEach(item => {
                // console.log(item)
                tempObj[item.pdslcode] = item
            })
            this.tabs = this.tabs.filter(item => {
                let obj = tempObj[item.meta.code]
                if (obj) {
                    item.code = obj.code
                    item.title = obj.pdslname || ''
                    item.order = obj.pdslseq
                    return item
                }
            })
            this.tabs = this.tabs.sort((a, b) => a.order - b.order)
        }
    }
  },
  watch: {
    $route(to) {
      const { histories } = this;
      const flag = histories.find((item) => item.path === to.path);
      if (flag) {
        return;
      }
      const ele = {};
      ele.stageId = to.meta.code || ''
      ele.path = to.path;
      ele.routePath = to.matched[to.matched.length - 1].path;
      ele.query = to.query
      ele.params = to.params
      ele.title = to.meta.title
      this.histories = [ele, ...histories];
    },
  },
  computed: {
    printIcon () {
      if (this.histories.length > 1) {
        return " top: 45px;"
      }
      return ""
    },
    asideWidth () {
      // let idx = this.tabs.findIndex(item => item.name === 'P04' )
      // if (idx > 0) {
      //   return '170px'
      // } else {
      //   return '125px'
      // }
      return '125px'
    }
  },
  components: { swiper, swiperSlide },
};
</script>
<style  lang="scss">
.el-tabs__active-bar {
  background: #f46722;
}
.container-da {
  display: flex;
  flex-direction: row;
  height: 100vh;
  // width: 100vw;
  position: relative;
  top: 0;
  left: 0;
  .left {
    width: 125px;
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .el-tabs {
    height: 100%;
    width: 100%;
  }
  .el-main {
    padding: 0;
  }
  .header {
    height: 40px;
    padding: 0;
    border-bottom: 1px solid rgba(190, 204, 216, 0.4);
    background: #eef4f9;
    height: 40px !important;
    box-shadow: 0 2px 6px 0 rgba(190, 204, 216, 0.4);
  }
}
.history-wrapper {
  width: auto;
  display: flex;
  align-items: center;
  user-select: none;
  .history-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 140px;
    height: 40px;
    color: #8c98ae;
    font-size: 14px;
    box-sizing: border-box;
    background: #fff;
    cursor: pointer;
    margin-right: 1px;
    > i {
      color: #fff;
    }
    .el-icon-close {
      position: absolute;
      opacity: 0;
    }
    &:hover {
      color: #fff;
      background: #f46722;
      border: none;
      > i {
        color: #fff;
      }
      .el-icon-close {
        display: inline-block;
        position: absolute;
        right: 0;
        top: 0;
        border-radius: 0 0 0 14px;
        width: 14px;
        height: 14px;
        background: rgba(255, 255, 255, 0.3);
        opacity: 1;
        &::before {
          position: absolute;
          right: -1px;
          font-size: 12px;
          transform: scale(0.7);
        }
      }
    }
  }
  .item-active {
    position: relative;
    box-sizing: border-box;
    border: none;
    height: 40px;
    background: #f46722;
    color: #fff;
    > i {
      color: #fff;
    }
    .el-icon-close {
      display: inline-block;
      position: absolute;
      right: 0;
      top: 0;
      border-radius: 0 0 0 14px;
      width: 14px;
      height: 14px;
      background: rgba(255, 255, 255, 0.3);
      opacity: 1;

      &::before {
        position: absolute;
        right: -1px;
        font-size: 12px;
        transform: scale(0.7);
      }
    }
  }
}
.icon {
  position: fixed;
  top: 10px;
  right: 10px;
  font-size: 46px;
  color: #fc5b2b;
  cursor: pointer;
}
</style>
